const gradientWithComma = (color: string) => {
  const [left, right] = color.split(', ');

  return `linear-gradient(to right bottom, ${left} , ${right})`;
};

export default gradientWithComma;
